import React , {useEffect} from 'react'
import './AboutMe.css'


function AboutMe() {
  useEffect(()=> {
    document.title = "LeeBakes - About Me"
  })
  return (
   <>
   <div className="full-div">
      <div className="center-div">
        <div className="left-content">
          <div className="img-div">
            <img src="https://images.pexels.com/photos/5900406/pexels-photo-5900406.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="" className='img-fluid abt-photo' width='400' />
          </div>
        </div>
        <div className="right-content">
          <h1>About <span style={{color:"#0a58ca"}}>Me?</span></h1>
          <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Nulla voluptate doloremque praesentium nam similique, repudiandae eligendi natus culpa excepturi nostrum sunt odio quidem ipsam deserunt vero reiciendis eveniet ad aliquid atque asperiores dolores dolore.</p>
          <div className="social-media-div">
          <label>Want to know more about me? Follow me on:</label>
          <div className="social-media-flex d-flex gap-4 mt-5">
            <a href="https://www.instagram.com/leebakes2022/" target='_blank'>
            <div className="social-icon-div insta">
            <i class="fa-brands fa-instagram fs-3"></i>
            </div>
            </a>
            <a href="https://www.instagram.com/leebakes2022/" target='_blank'>
            <div className="social-icon-div snap">
            <i class="fa-brands fa-snapchat fs-3"></i>
            </div>
            </a>
            <a href="https://www.instagram.com/leebakes2022/" target='_blank'>
            <div className="social-icon-div fb">
            <i class="fa-brands fa-facebook fs-3"></i>
            </div>
            </a>
            
          </div>
        </div>
        </div>
        {/* From here , add "Follow me on" with label tag and use font awesome icons  */}
        
        
      </div>
    </div>
   </>
  )
}

export default AboutMe